import AttendanceEvaluationFormContainer from './AttendanceEvaluationFormContainer';

export default AttendanceEvaluationFormContainer;
